import axios from "axios";

import Config from "./Config";
import APIHelper from "./APIHelper";

const CrawlingSchedulerService = {
    rules() {
        return axios
            .get(Config.API_URL + "scheduler/rules")
            .then(APIHelper.returnData)
            .catch(APIHelper.returnFalse);
    },
    updateRule(id, row) {
        return axios
            .post(Config.API_URL + "scheduler/rules/" + id, row)
            .then((response) => APIHelper.returnAttribute(response, "rule"))
            .catch(APIHelper.returnFalse);
    },
    addRule(row) {
        return axios
            .post(Config.API_URL + "scheduler/rules", row)
            .then((response) => {
                if (!APIHelper.checkStatus(response)) {
                    return { _error: response.data?.error ?? null };
                }
                return APIHelper.returnAttribute(response, "rule");
            })
            .catch((error) => ({
                _error: error.response?.data?.error ?? null,
            }));
    },
    deleteRule(id) {
        return axios
            .delete(Config.API_URL + "scheduler/rules/" + id)
            .then(APIHelper.checkStatus)
            .catch(APIHelper.returnFalse);
    },
};

export default CrawlingSchedulerService;
